import React from "react";
import SectionHeader from "../Common/Section-Header/SectionHeader";
import Fade from "react-reveal/Fade";
import "./Skills.scss";
import SkillCard from "./Skill-Card/SkillCard";
import SkillsData from "data/skills.json";

const skillsDataWithId = SkillsData.map((data, index) => ({
  id: index + 1,
  ...data,
}));

const Skills = () => {
  return (
    <section className="section-separator" id="skills">
      <div className="container mb-5">
        <Fade bottom>
          <SectionHeader subtitle="Professionalism" title="My Skills" />
        </Fade>
        <div>
          <ul className="skill-area">
            {skillsDataWithId.map((skill) => (
              <SkillCard key={skill.id} imgURL={skill.url} name={skill.name} />
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Skills;
